import { Card, CardContent } from "@/components/Card";
import { TrendingUp, TrendingDown } from "lucide-react";
import { HelpTooltip } from "@/components/HelpTooltip";
import { cn } from "@/lib/utils";

export function MetricCard({
  title,
  value,
  icon: Icon,
  color = "orange",
  trend = null,
  suffix = "",
  helpText = null,
  className = ""
}) {
  const colorClasses = {
    orange: "bg-orange-50 border-orange-100 text-orange-700",
    green: "bg-green-50 border-green-100 text-green-700",
    blue: "bg-blue-50 border-blue-100 text-blue-700",
    purple: "bg-purple-50 border-purple-100 text-purple-700",
    red: "bg-red-50 border-red-100 text-red-700"
  };

  const iconColorClasses = {
    orange: "text-orange-200",
    green: "text-green-200",
    blue: "text-blue-200",
    purple: "text-purple-200",
    red: "text-red-200"
  };

  const textColorClasses = {
    orange: "text-orange-600",
    green: "text-green-600",
    blue: "text-blue-600",
    purple: "text-purple-600",
    red: "text-red-600"
  };

  const valueColorClasses = {
    orange: "text-orange-700",
    green: "text-green-700",
    blue: "text-blue-700",
    purple: "text-purple-700",
    red: "text-red-700"
  };

  return (
    <div className={cn(colorClasses[color], "border rounded-xl p-4", className)}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className={cn("text-xs font-medium uppercase flex items-center gap-1", textColorClasses[color])}>
            {title}
            {helpText && <HelpTooltip content={helpText} />}
          </p>
          <h3 className={cn("text-2xl font-bold", valueColorClasses[color])}>
            {typeof value === 'number' ? value.toLocaleString() : value}{suffix}
          </h3>
        </div>
        {Icon && <Icon className={cn("w-8 h-8", iconColorClasses[color])} />}
      </div>

      {trend !== null && trend !== undefined && (
        <div className="mt-2 flex items-center gap-1">
          {trend > 0 ? (
            <>
              <TrendingUp className="w-3 h-3 text-green-600" />
              <span className="text-xs font-medium text-green-600">+{trend}%</span>
            </>
          ) : trend < 0 ? (
            <>
              <TrendingDown className="w-3 h-3 text-red-600" />
              <span className="text-xs font-medium text-red-600">{trend}%</span>
            </>
          ) : (
            <span className="text-xs font-medium text-gray-500">Sin cambios</span>
          )}
          <span className="text-xs text-gray-500 ml-1">vs período anterior</span>
        </div>
      )}
    </div>
  );
}
